import { createValidIcon } from '@ui/icons/utils/type-helper'

export const LogoIcon = createValidIcon((props) => {
  const { size, color, secondaryColor } = props

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M13.0932 16.0112H9.87991C9.48976 16.0112 9.12919 15.803 8.93469 15.4652L7.08863 12.2667C6.89412 11.9289 6.89412 11.5126 7.08863 11.1748L8.93469 7.9763C9.12919 7.63848 9.48976 7.43033 9.87991 7.43033H13.092L15.6433 3.01137C15.5887 3.00682 15.5353 3 15.4795 3H7.97356C7.18076 3 6.44825 3.42313 6.05128 4.11014L2.29773 10.6106C1.90076 11.2976 1.90076 12.1427 2.29773 12.8298L6.05128 19.3302C6.44825 20.0173 7.18076 20.4404 7.97356 20.4404H15.4795C15.5353 20.4404 15.5899 20.4336 15.6445 20.429L13.0932 16.01V16.0112Z'
        fill={color}
      />
      <path
        d='M21.1554 10.6117L17.4018 4.11126C17.3734 4.06349 17.3404 4.01913 17.3097 3.97363L14.7584 8.39259L16.3656 11.1759C16.5601 11.5137 16.5601 11.93 16.3656 12.2678L14.7596 15.05L17.3108 19.469C17.3416 19.4235 17.3745 19.3803 17.4018 19.3325L21.1554 12.832C21.5524 12.145 21.5524 11.2999 21.1554 10.6129V10.6117Z'
        fill={secondaryColor}
      />
    </svg>
  )
})
